export default {
  safeManagerApi: {
    grabbingSettings: {
      getList: '/api/grabSetting/getList',
      getLawyerList: '/api/grabSetting/getLawyerList',
      add: '/api/grabSetting/add',
      update: '/api/grabSetting/update',
      del: '/api/grabSetting/del',
      grantLawyer: '/api/grabSetting/grantLawyer',
      changeStatus: '/api/grabSetting/changeStatus'
    },
  }
}
